export default __webpack_public_path__ + "static/media/a.141a62ce.jpg";